export default "__VITE_ASSET__1lD9yws$__"